<template>
  <QBtnDropdown
    color="primary-semi-dark"
    :label="label"
    padding="4px 10px 4px 16px"
  >
    <QList>
      <QItem
        v-for="item in options"
        :key="item.value"
        clickable
        v-close-popup
        @click="$emit('input', item.value)"
      >
        <QItemSection>
          <QItemLabel>
            {{ item.adverbLabel }}
          </QItemLabel>
        </QItemSection>
      </QItem>
    </QList>
  </QBtnDropdown>
</template>

<script>
import {
  QBtnDropdown,
  QList,
  QItem,
  QItemSection,
  QItemLabel,
  ClosePopup
} from 'quasar';

export default {
  name: 'FrequencyDropdown',
  props: {
    value: undefined
  },
  data() {
    let options = Object.values(this.$Constants.CALCULATION_FREQUENCIES);
    return {
      defaultLabel: options[0].adverbLabel,
      options
    };
  },
  computed: {
    label() {
      let match = this.$Constants.CALCULATION_FREQUENCIES[this.value];
      return match ? match.adverbLabel : this.defaultLabel;
    }
  },
  directives: {
    ClosePopup
  },
  components: {
    QBtnDropdown,
    QList,
    QItem,
    QItemSection,
    QItemLabel
  }
};
</script>
